export default __webpack_public_path__ + "static/media/printtaa.39c4641e.svg";